import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Field, reduxForm, formValueSelector } from 'redux-form/immutable';
import v from 'validator';

import Header from '../../components/header';
import Tabs from '../../components/tabs';
import TextField from '../../components/form-input-text';
import StatusBar from '../../containers/status-bar';
import { setStatusBar, clearStatusBar } from '../../containers/status-bar/actions';
import { loadProfile } from './actions';
import { fetchUser, updateUser } from '../../utils/jsonapi-functions/users';
import { authService } from '../../utils/auth-service';

const Scroll = require('react-scroll');

const scroll = Scroll.animateScroll;

class UserProfile extends React.Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      updateProfileLoading: false,
    };
  }

  handleTabChange = tab => event => {
    if (event) event.preventDefault();
    if (tab === 'NOTIFICATIONS_SETTINGS') {
      this.context.router.push('/profile/settings');
    }
  };

  handleUpdate = formData => {
    this.setState({ updateProfileLoading: true });
    const email = formData.get('email');
    updateUser(authService.uid(), {
      name: formData.get('name'),
      email,
    }).then(() => {
      this.props.onSetStatusBar('Profile has been updated.', 'green');
      scroll.scrollToTop();
      this.setState({ updateProfileLoading: false });
      // TODO Get authService working with getting the profile again after updating the user
      // this.setState({ updateProfileLoading: true });
      // authService.renewProfile(email, this.updateUserResponse);
    });
  };

  updateUserResponse = (error, result) => {
    this.setState({ updateProfileLoading: false });
    if (error) {
      this.props.onSetStatusBar(error.message, 'red');
    } else {
      this.props.onSetStatusBar('Profile has been updated.', 'green');
    }
  };

  componentDidMount() {
    const uid = authService.uid();
    fetchUser(uid).then(user => {
      const userData = user.toJSONTree();
      this.props.onLoadProfile({
        name: userData.name,
        email: userData.email,
      });
    });
  }

  componentWillUnmount() {
    this.props.onClearStatusBar();
  }

  render() {
    const { updateProfileLoading } = this.state;
    const { loading, handleSubmit } = this.props;
    return (
      <div className="page profile">
        <Tabs
          headerStyle="padded-content white border-bottom"
          tabsStyle={'tabs'}
          data={['PROFILE', 'NOTIFICATIONS_SETTINGS']}
          panesTitles={{ PROFILE: 'Profile', NOTIFICATIONS_SETTINGS: 'Notification preferences' }}
          active={'PROFILE'}
          onClick={this.handleTabChange}
        />
        <div className="page-content">
          <div className="grid">

            <StatusBar />

            { !loading &&
              <form onSubmit={handleSubmit(this.handleUpdate.bind(this))}>

                <div className="profile-header">
                  <h3 className="label">Profile</h3>
                </div>

                {/* TODO Allow for profile image upload
                <div className="grid-6-6">
                  <div className="picture" />
                </div>
                */}

                <div className="profile-form">
                  <div className="form-row">
                    <div className="form-title">
                      <p>Full name</p>
                    </div>
                    <div className="form-input">
                      <Field
                        id="name"
                        type="text"
                        component={TextField}
                        name="name"
                      />
                    </div>
                    <div className="form-comment">
                      <p className="small light">
                        Only new campaigns will use an updated name.
                      </p>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-title">
                      <p>E-mail</p>
                    </div>
                    <div className="form-input">
                      <Field
                        id="email"
                        type="text"
                        disabled
                        component={TextField}
                        name="email"
                      />
                    </div>
                    <div className="form-comment">
                      <p className="small light">
                        You must use the email you were assigned when signing up to the platform.
                      </p>
                    </div>
                  </div>

                  <div className="form-row">
                    <div className="form-submit">
                      { updateProfileLoading &&
                        <button className="medium rose" disabled>
                          <ul className="dots">
                            <li id="dot1" />
                            <li />
                            <li id="dot2" />
                            <li />
                            <li id="dot3" />
                          </ul>
                        </button>
                      }
                      { !updateProfileLoading &&
                        <button className="medium rose" type="submit">Save</button>
                      }
                    </div>
                  </div>
                </div>
              </form>
            }
          </div>
        </div>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};

  const name = values.get('name');
  const email = values.get('email');

  if (!name || (name && v.isEmpty(name))) errors.name = 'Invalid name';
  if (!email || (email && !v.isEmail(email))) errors.email = 'Invalid e-mail';

  return errors;
}

const mapStateToProps = state => ({
  loading: state.userProfile.get('loading'),
  initialValues: {
    name: state.userProfile.get('name'),
    email: state.userProfile.get('email'),
  },
});

export function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    onLoadProfile: data => dispatch(loadProfile(data)),
    onSetStatusBar: (message, colour) => dispatch(setStatusBar(message, colour)),
    onClearStatusBar: () => dispatch(clearStatusBar()),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'EditProfileForm',
    enableReinitialize: true,
    validate,
  })(UserProfile),
);



/** WEBPACK FOOTER **
 ** ./src/containers/user-profile/index.js
 **/